import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import Header from '../elementos/basicos/Header';
import Cabecera from '../elementos/basicos/Cabecera';
import ContenedorBlog from '../elementos/basicos/ContenedorBlog';
import { Navigate } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Footer from '../elementos/basicos/Footer';
import { StyleSheetManager } from 'styled-components';
import CargaCards from '../elementos/eventos/CargaCards';
import { useParams } from 'react-router-dom';
import Col from 'react-bootstrap/Col';
import styled from 'styled-components';



const Publicacion = () => {

    const { urlPublicacion } = useParams(); 
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorData, setErrorData] = useState(true);
    const urlPadre = window.location.pathname;

    function limpiarHTML(contenidoHTML) {
        let contenidoLimpio = contenidoHTML;
        
        // 1. Primero reemplazar los &nbsp; con párrafos vacíos
        contenidoLimpio = contenidoLimpio.replace(/<p>&nbsp;<\/p>/g, '<p></p>');
        
        // 2. Manejar dobles <p><br></p> - convertir el segundo en display: none
        contenidoLimpio = contenidoLimpio.replace(/(<p><br><\/p>)\s*(<p><br><\/p>)/g, '$1<p><br style="display: none;"></p>');
        
        // 3. Manejar <p><br></p> individuales que NO forman parte de un par doble
        // Usamos lookahead y lookbehind negativos para asegurar que no están precedidos o seguidos por otro <p><br></p>
        contenidoLimpio = contenidoLimpio.replace(/(?<!<p><br><\/p>\s*)(?<!<p><br style="display: none;"><\/p>\s*)<p><br><\/p>(?!\s*<p><br><\/p>)(?!\s*<p><br style="display: none;"><\/p>)/g, '<br style="display: none;">');
        
        return contenidoLimpio;
    }


    useEffect(() => {
        const obtenerDatos = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/comunicacion/blog/${urlPublicacion}`); //importante la autorización , {headers: {'Authorization': `Bearer ${localStorage.getItem("token")}`}}
                setErrorData(false);
                response.data.contenido = limpiarHTML(response.data.contenido);
                setData(response.data);
                console.log("mmmmmmmmmm" + response.data)
                setLoading(false);
            } catch (error) {
                setErrorData(error.code)
                setLoading(false);

            }
        };

        obtenerDatos();
    }, [urlPadre]);


    return (
      <>
        <Helmet>
          <title>TusCursosSepe | Blog</title>
          <meta name="description" content="Blog de TusCursosSepe" />
          <meta property='og:image' content='%PUBLIC_URL%/favicon.ico' />
        </Helmet>
        <Header />
        <StyleSheetManager shouldForwardProp={() => true}>
          <Cabecera Titulo="BLOG" MargenMenor="true"></Cabecera>
        </StyleSheetManager>

        <FilaBlog>
          <Col lg="2"></Col>

          <Col lg="8">
            {loading ? (
              <CargaCards alineado="true" />
            ) : errorData === "ERR_BAD_RESPONSE" ? (
              <Navigate to="/*" replace />
            ) : (
              <ContenedorBlog publicacion={data} />
            )}
          </Col>

          <Col lg="2"></Col>
        </FilaBlog>

        <Footer />
      </>
    );
}

const FilaBlog = styled(Row)`
    width: 100%;
    margin: 0;
`


export default Publicacion;
